import { gql } from '@apollo/client';

export default gql`
  mutation inviteSpaceUser($email: String!, $role: String!) {
    inviteSpaceUser(input: { email: $email, role: $role }) {
      success
    }
  }
`;
